import { v3, V3Error } from './generation-v3';

export class SaveUnconfirmedError extends Error {
  constructor(public operationId: string) {
    super('We couldn’t confirm the save yet. It may still finish. Keep this page open to check automatically, or check your Library.');
  }
}

/** A missing response is not evidence that the save failed or is safe to replay. */
export async function saveV3Library(generationId: string, title: string, previouslyUnconfirmed = false, signal?: AbortSignal) {
  try {
    signal?.throwIfAborted();
    const saved = await v3<{ library_deck_id: string }>(
      '/deck-generations/' + generationId + '/library-save', { title }, 'POST', undefined, signal, false,
    );
    signal?.throwIfAborted();
    if (typeof saved.library_deck_id !== 'string' || !saved.library_deck_id) throw new Error('Missing committed Library deck ID.');
    return saved;
  } catch (error) {
    signal?.throwIfAborted();
    // A rejected retry cannot disprove an earlier request that may still commit.
    if (!previouslyUnconfirmed && error instanceof V3Error && (!error.status || (error.status < 500 && error.status !== 408))) throw error;
    throw new SaveUnconfirmedError(generationId);
  }
}
